export function formatMoneyNumber(input) {
	if (input == null) {
		return ''
	}

	let inputStr = String(input)
	const parts = inputStr.split('.')

	let integerPart = parts[0].replace(/\D/g, '')

	let formattedInteger = ''
	for (let i = integerPart.length - 1, count = 0; i >= 0; i--, count++) {
		if (count > 0 && count % 3 === 0) {
			formattedInteger = ' ' + formattedInteger
		}
		formattedInteger = integerPart[i] + formattedInteger
	}

	if (parts.length > 1) {
		return formattedInteger + '.' + parts[1]
	}

	return formattedInteger
}
